export const ASSESSMENT_STATE_LOADING = 'loading';
export const ASSESSMENT_STATE_ASK_CODE = 'askCode';
export const ASSESSMENT_STATE_INTRO = 'intro';
export const ASSESSMENT_STATE_INTRO_TERMS = 'introTerms';
export const ASSESSMENT_STATE_QUESTION_GROUP_INTRO_DESCRIPTION = 'questionGroupIntroDescription';
export const ASSESSMENT_STATE_QUESTION_GROUP_INTRO_TITLE = 'questionGroupIntroTitle';
export const ASSESSMENT_STATE_QUESTION_INTRO = 'questionIntro';
export const ASSESSMENT_STATE_QUESTION = 'question';
export const ASSESSMENT_STATE_END = 'end';
export const ASSESSMENT_STATE_SUBMIT = 'submit';
export const ASSESSMENT_STATE_SUMMARY = 'summary';
export const ASSESSMENT_STATE_EDIT_ANSWERS = 'editAnswers';
